import Vue, { CreateElement } from 'src/vue'
import { Component } from 'vue-property-decorator'

import { Tabs, Tab } from 'src/components/tabs/tabs'
import { Loader } from '@src/components/loading-screen/loader/loader'
import { ClubService } from '@src/service/club'

import './club.sass'
import { EmojiService } from '@src/service/emoji'

enum ContentType {
  ARRANGEMENT = 'arrangement',
  SCHEDULE = 'schedule',
  STATISTICS = 'statistics',
  CLUB_INFO = 'club-info',
  GENERAL_SETTINGS = 'general-settings'
}

@Component
export class Club extends Vue {

  private loading: boolean = true

  constructor () {
    super()
    this.loading = true
  }

  selectTab (path: ContentType) {
    this.$router.push(`/trainers/platform/club/${path}`)
  }

  isTabSelected (path: ContentType) {
    return this.$route.path.indexOf(path) >= 0
  }

  render (h: CreateElement) {
    return <div class='club-wrapper'>

      <Tabs>
        <Tab label={this.$t('PAGE.CLUB.ARRANGEMENT_SETTINGS.TAB_NAME')} selected={this.isTabSelected(ContentType.ARRANGEMENT)}
             selectTab={() => this.selectTab(ContentType.ARRANGEMENT)} />
        <Tab label={this.$t('PAGE.CLUB.STARTUP_SHUTDOWN_SCHEDULE.TAB_NAME')} selected={this.isTabSelected(ContentType.SCHEDULE)}
             selectTab={() => this.selectTab(ContentType.SCHEDULE)} />
        <Tab label={this.$t('PAGE.CLUB.CLUB_STATISTICS.TAB_NAME')} selected={this.isTabSelected(ContentType.STATISTICS)}
             selectTab={() => this.selectTab(ContentType.STATISTICS)} />
        <Tab label={this.$t('PAGE.CLUB.GENERAL_SETTINGS.TAB_NAME')} selected={this.isTabSelected(ContentType.GENERAL_SETTINGS)}
             selectTab={() => this.selectTab(ContentType.GENERAL_SETTINGS)} />
        <Tab label={this.$t('CONTACT')} selected={this.isTabSelected(ContentType.CLUB_INFO)}
             selectTab={() => this.selectTab(ContentType.CLUB_INFO)} />
      </Tabs>

      <div class='component-tabs-body scroll-content'>
        {this.loading ?
          <Loader />
          : <router-view />}
      </div>
    </div>
  }

  created () {
    return {
      clubPromise: ClubService.loadClub(this.$store).finally(() => this.loading = false),
      emojiPromise: new EmojiService().getEmojis().then(response => {
        this.$store.dispatch('updateEmojiData', response)
        Object.keys(response).forEach((key) => {
          if (response[key].selected) {
            this.$store.dispatch('updateEmojiActiveType', key)
            return
          }
        })
      })
    }
  }
}
